// packages/i18n/src/config.ts

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all locale files
import enUSAdmin from '../locales/en-US/admin.json';
import enUSAdminPricing from '../locales/en-US/admin_pricing.json';
// Phase 12 analista-queue-kpis-notif Plan 02 — 4 namespaces novos.
import enUSAnalyst from '../locales/en-US/analyst.json';
// Aniversariantes de associado (visão do consultor — carteira SGA).
import enUSAssociates from '../locales/en-US/associates.json';
import enUSAttachments from '../locales/en-US/attachments.json';
import enUSAuth from '../locales/en-US/auth.json';
import enUSCommissions from '../locales/en-US/commissions.json';
import enUSCommon from '../locales/en-US/common.json';
// Phase 13 (ESCR-172.5) — Alamo Cobre namespace.
import enUSCompetitorOffer from '../locales/en-US/competitor_offer.json';
import enUSConsultor from '../locales/en-US/consultor.json';
import enUSContracts from '../locales/en-US/contracts.json';
// Phase 11 docs-signature-payment Plan 09 — 3 namespaces novos.
import enUSDocument from '../locales/en-US/document.json';
// Endosso — tela /endossos (busca CPF → apólices ativas → trocar plano via amend).
import enUSEndossos from '../locales/en-US/endossos.json';
import enUSErrors from '../locales/en-US/errors.json';
import enUSInspection from '../locales/en-US/inspection.json';
import enUSKpi from '../locales/en-US/kpi.json';
import enUSMagicLink from '../locales/en-US/magic-link.json';
import enUSMaterials from '../locales/en-US/materials.json';
// Dashboard de gestão comercial (tela /metricas — ESCR-244).
import enUSMetrics from '../locales/en-US/metrics.json';
import enUSMyRegistration from '../locales/en-US/my_registration.json';
import enUSNotification from '../locales/en-US/notification.json';
// Troca de titularidade (WAVE 2) — magic-link do antigo + fila do analista.
import enUSOwnershipTransfer from '../locales/en-US/ownership_transfer.json';
import enUSPayment from '../locales/en-US/payment.json';
import enUSPaymentIncidents from '../locales/en-US/payment_incidents.json';
import enUSPaymentOnboardingOps from '../locales/en-US/payment_onboarding_ops.json';
import enUSPayments from '../locales/en-US/payments.json';
// Repasse manual da adesão (pending_payouts) — docs/contracts/ESCR-pending-payouts.md.
import enUSPayouts from '../locales/en-US/payouts.json';
// Phase 18 Plan 09 — magic-link cliente filtered view pendencias.
import enUSPendencias from '../locales/en-US/pendencias.json';
import enUSPolicy from '../locales/en-US/policy.json';
// SGA/Hinova — consulta de carteira (tela /portfolio do consultor).
import enUSPortfolio from '../locales/en-US/portfolio.json';
import enUSPortfolioTransfer from '../locales/en-US/portfolio_transfer.json';
import enUSPreApproval from '../locales/en-US/pre_approval.json';
// Phase 11 docs-signature-payment Plan 10 — PreCompletionHub namespace.
import enUSPrecompletion from '../locales/en-US/precompletion.json';
import enUSPricing from '../locales/en-US/pricing.json';
import enUSProposal from '../locales/en-US/proposal.json';
import enUSPublicQuotation from '../locales/en-US/public_quotation.json';
import enUSQuotation from '../locales/en-US/quotation.json';
// Cotação de frota (admin-only) — docs/contracts/ESCR-fleet-quotations.md.
import enUSQuotationFleet from '../locales/en-US/quotation_fleet.json';
import enUSReactivationBilling from '../locales/en-US/reactivation_billing.json';
import enUSRegistration from '../locales/en-US/registration.json';
import enUSRegistrationConference from '../locales/en-US/registration_conference.json';
// Lembretes do consultor (tela /agenda — ESCR-246).
import enUSReminders from '../locales/en-US/reminders.json';
// Relatórios gerenciais (menu Relatórios — admin/gerente).
import enUSReports from '../locales/en-US/reports.json';
import enUSResponsibleReview from '../locales/en-US/responsible_review.json';
import enUSSelfieLab from '../locales/en-US/selfie_lab.json';
import enUSSignature from '../locales/en-US/signature.json';
// Bancada da selfie (/selfie-lab) — ferramenta interna de comparação.
// Central de Suporte / FAQ — vitrine do consultor.
import enUSSupport from '../locales/en-US/support.json';
import enUSUi from '../locales/en-US/ui.json';
import enUSWarRoom from '../locales/en-US/war_room.json';
import ptBRAdmin from '../locales/pt-BR/admin.json';
import ptBRAdminPricing from '../locales/pt-BR/admin_pricing.json';
import ptBRAnalyst from '../locales/pt-BR/analyst.json';
// Aniversariantes de associado (visão do consultor — carteira SGA).
import ptBRAssociates from '../locales/pt-BR/associates.json';
import ptBRAttachments from '../locales/pt-BR/attachments.json';
import ptBRAuth from '../locales/pt-BR/auth.json';
import ptBRCommissions from '../locales/pt-BR/commissions.json';
import ptBRCommon from '../locales/pt-BR/common.json';
// Phase 13 (ESCR-172.5) — Alamo Cobre namespace.
import ptBRCompetitorOffer from '../locales/pt-BR/competitor_offer.json';
import ptBRConsultor from '../locales/pt-BR/consultor.json';
import ptBRContracts from '../locales/pt-BR/contracts.json';
import ptBRDocument from '../locales/pt-BR/document.json';
// Endosso — tela /endossos (busca CPF → apólices ativas → trocar plano via amend).
import ptBREndossos from '../locales/pt-BR/endossos.json';
import ptBRErrors from '../locales/pt-BR/errors.json';
import ptBRInspection from '../locales/pt-BR/inspection.json';
import ptBRKpi from '../locales/pt-BR/kpi.json';
import ptBRMagicLink from '../locales/pt-BR/magic-link.json';
import ptBRMaterials from '../locales/pt-BR/materials.json';
// Dashboard de gestão comercial (tela /metricas — ESCR-244).
import ptBRMetrics from '../locales/pt-BR/metrics.json';
import ptBRMyRegistration from '../locales/pt-BR/my_registration.json';
import ptBRNotification from '../locales/pt-BR/notification.json';
// Troca de titularidade (WAVE 2) — magic-link do antigo + fila do analista.
import ptBROwnershipTransfer from '../locales/pt-BR/ownership_transfer.json';
import ptBRPayment from '../locales/pt-BR/payment.json';
import ptBRPaymentIncidents from '../locales/pt-BR/payment_incidents.json';
import ptBRPaymentOnboardingOps from '../locales/pt-BR/payment_onboarding_ops.json';
import ptBRPayments from '../locales/pt-BR/payments.json';
// Repasse manual da adesão (pending_payouts) — docs/contracts/ESCR-pending-payouts.md.
import ptBRPayouts from '../locales/pt-BR/payouts.json';
// Phase 18 Plan 09 — magic-link cliente filtered view pendencias.
import ptBRPendencias from '../locales/pt-BR/pendencias.json';
import ptBRPolicy from '../locales/pt-BR/policy.json';
// SGA/Hinova — consulta de carteira (tela /portfolio do consultor).
import ptBRPortfolio from '../locales/pt-BR/portfolio.json';
import ptBRPortfolioTransfer from '../locales/pt-BR/portfolio_transfer.json';
import ptBRPreApproval from '../locales/pt-BR/pre_approval.json';
// Phase 11 docs-signature-payment Plan 10 — PreCompletionHub namespace.
import ptBRPrecompletion from '../locales/pt-BR/precompletion.json';
import ptBRPricing from '../locales/pt-BR/pricing.json';
import ptBRProposal from '../locales/pt-BR/proposal.json';
import ptBRPublicQuotation from '../locales/pt-BR/public_quotation.json';
import ptBRQuotation from '../locales/pt-BR/quotation.json';
// Cotação de frota (admin-only) — docs/contracts/ESCR-fleet-quotations.md.
import ptBRQuotationFleet from '../locales/pt-BR/quotation_fleet.json';
import ptBRReactivationBilling from '../locales/pt-BR/reactivation_billing.json';
import ptBRRegistration from '../locales/pt-BR/registration.json';
import ptBRRegistrationConference from '../locales/pt-BR/registration_conference.json';
// Lembretes do consultor (tela /agenda — ESCR-246).
import ptBRReminders from '../locales/pt-BR/reminders.json';
// Relatórios gerenciais (menu Relatórios — admin/gerente).
import ptBRReports from '../locales/pt-BR/reports.json';
import ptBRResponsibleReview from '../locales/pt-BR/responsible_review.json';
import ptBRSelfieLab from '../locales/pt-BR/selfie_lab.json';
import ptBRSignature from '../locales/pt-BR/signature.json';
// Bancada da selfie (/selfie-lab) — ferramenta interna de comparação.
// Central de Suporte / FAQ — vitrine do consultor.
import ptBRSupport from '../locales/pt-BR/support.json';
import ptBRUi from '../locales/pt-BR/ui.json';
import ptBRWarRoom from '../locales/pt-BR/war_room.json';

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': {
      materials: ptBRMaterials,
      common: ptBRCommon,
      errors: ptBRErrors,
      auth: ptBRAuth,
      ui: ptBRUi,
      consultor: ptBRConsultor,
      admin: ptBRAdmin,
      admin_pricing: ptBRAdminPricing,
      // Aniversariantes de associado (visão do consultor — carteira SGA).
      associates: ptBRAssociates,
      registration: ptBRRegistration,
      registration_conference: ptBRRegistrationConference,
      responsible_review: ptBRResponsibleReview,
      my_registration: ptBRMyRegistration,
      pre_approval: ptBRPreApproval,
      attachments: ptBRAttachments,
      quotation: ptBRQuotation,
      // Cotação de frota (admin-only).
      quotation_fleet: ptBRQuotationFleet,
      contracts: ptBRContracts,
      pricing: ptBRPricing,
      public_quotation: ptBRPublicQuotation,
      proposal: ptBRProposal,
      'magic-link': ptBRMagicLink,
      // Dashboard de gestão comercial (tela /metricas — ESCR-244).
      metrics: ptBRMetrics,
      inspection: ptBRInspection,
      // Phase 11 docs-signature-payment Plan 09 — 3 namespaces novos.
      document: ptBRDocument,
      signature: ptBRSignature,
      // Bancada da selfie (/selfie-lab).
      selfie_lab: ptBRSelfieLab,
      payment: ptBRPayment,
      payments: ptBRPayments,
      // Repasse manual da adesão (pending_payouts).
      payouts: ptBRPayouts,
      payment_incidents: ptBRPaymentIncidents,
      reactivation_billing: ptBRReactivationBilling,
      payment_onboarding_ops: ptBRPaymentOnboardingOps,
      // Phase 18 Plan 09 — magic-link cliente pendencias.
      pendencias: ptBRPendencias,
      // Phase 12 analista-queue-kpis-notif Plan 16 — Admin Hinova sync namespace.
      policy: ptBRPolicy,
      // Phase 11 docs-signature-payment Plan 10 — PreCompletionHub namespace.
      precompletion: ptBRPrecompletion,
      // Phase 12 analista-queue-kpis-notif Plan 02 — 4 namespaces novos.
      analyst: ptBRAnalyst,
      kpi: ptBRKpi,
      notification: ptBRNotification,
      // Troca de titularidade (WAVE 2).
      ownership_transfer: ptBROwnershipTransfer,
      war_room: ptBRWarRoom,
      // Phase 13 (ESCR-172.5) — Alamo Cobre.
      competitor_offer: ptBRCompetitorOffer,
      // Comissão MLM Genial.
      commissions: ptBRCommissions,
      // SGA/Hinova — consulta de carteira (tela /portfolio do consultor).
      portfolio: ptBRPortfolio,
      portfolio_transfer: ptBRPortfolioTransfer,
      // Endosso — tela /endossos.
      endossos: ptBREndossos,
      // Lembretes do consultor (tela /agenda — ESCR-246).
      reminders: ptBRReminders,
      // Central de Suporte / FAQ — vitrine do consultor.
      support: ptBRSupport,
      // Relatórios gerenciais (menu Relatórios — admin/gerente).
      reports: ptBRReports,
    },
    'en-US': {
      materials: enUSMaterials,
      common: enUSCommon,
      errors: enUSErrors,
      auth: enUSAuth,
      ui: enUSUi,
      consultor: enUSConsultor,
      admin: enUSAdmin,
      admin_pricing: enUSAdminPricing,
      // Aniversariantes de associado (visão do consultor — carteira SGA).
      associates: enUSAssociates,
      registration: enUSRegistration,
      registration_conference: enUSRegistrationConference,
      responsible_review: enUSResponsibleReview,
      my_registration: enUSMyRegistration,
      pre_approval: enUSPreApproval,
      attachments: enUSAttachments,
      quotation: enUSQuotation,
      // Cotação de frota (admin-only).
      quotation_fleet: enUSQuotationFleet,
      contracts: enUSContracts,
      pricing: enUSPricing,
      public_quotation: enUSPublicQuotation,
      proposal: enUSProposal,
      'magic-link': enUSMagicLink,
      // Dashboard de gestão comercial (tela /metricas — ESCR-244).
      metrics: enUSMetrics,
      inspection: enUSInspection,
      // Phase 11 docs-signature-payment Plan 09 — 3 namespaces novos.
      document: enUSDocument,
      signature: enUSSignature,
      // Bancada da selfie (/selfie-lab).
      selfie_lab: enUSSelfieLab,
      payment: enUSPayment,
      payments: enUSPayments,
      // Repasse manual da adesão (pending_payouts).
      payouts: enUSPayouts,
      payment_incidents: enUSPaymentIncidents,
      reactivation_billing: enUSReactivationBilling,
      payment_onboarding_ops: enUSPaymentOnboardingOps,
      // Phase 18 Plan 09 — magic-link cliente pendencias.
      pendencias: enUSPendencias,
      // Phase 12 analista-queue-kpis-notif Plan 16 — Admin Hinova sync namespace.
      policy: enUSPolicy,
      // Phase 11 docs-signature-payment Plan 10 — PreCompletionHub namespace.
      precompletion: enUSPrecompletion,
      // Phase 12 analista-queue-kpis-notif Plan 02 — 4 namespaces novos.
      analyst: enUSAnalyst,
      kpi: enUSKpi,
      notification: enUSNotification,
      // Troca de titularidade (WAVE 2).
      ownership_transfer: enUSOwnershipTransfer,
      war_room: enUSWarRoom,
      // Phase 13 (ESCR-172.5) — Alamo Cobre.
      competitor_offer: enUSCompetitorOffer,
      // Comissão MLM Genial.
      commissions: enUSCommissions,
      // SGA/Hinova — consulta de carteira (tela /portfolio do consultor).
      portfolio: enUSPortfolio,
      portfolio_transfer: enUSPortfolioTransfer,
      // Endosso — tela /endossos.
      endossos: enUSEndossos,
      // Lembretes do consultor (tela /agenda — ESCR-246).
      reminders: enUSReminders,
      // Central de Suporte / FAQ — vitrine do consultor.
      support: enUSSupport,
      // Relatórios gerenciais (menu Relatórios — admin/gerente).
      reports: enUSReports,
    },
  },
  lng: 'pt-BR',
  fallbackLng: 'en-US',
  defaultNS: 'common',
  ns: [
    'common',
    'errors',
    'auth',
    'ui',
    'consultor',
    'admin',
    'admin_pricing',
    // Aniversariantes de associado (visão do consultor — carteira SGA).
    'associates',
    'registration',
    'registration_conference',
    'responsible_review',
    'my_registration',
    'pre_approval',
    'attachments',
    'quotation',
    // Cotação de frota (admin-only).
    'quotation_fleet',
    'contracts',
    'pricing',
    'public_quotation',
    'proposal',
    'magic-link',
    // Dashboard de gestão comercial (tela /metricas — ESCR-244).
    'metrics',
    'inspection',
    // Phase 11 docs-signature-payment Plan 09.
    'document',
    'signature',
    // Bancada da selfie (/selfie-lab).
    'selfie_lab',
    'payment',
    'payments',
    // Repasse manual da adesão (pending_payouts).
    'payouts',
    'payment_incidents',
    'reactivation_billing',
    'payment_onboarding_ops',
    // Phase 18 Plan 09 — magic-link cliente filtered view pendencias.
    'pendencias',
    // Phase 12 analista-queue-kpis-notif Plan 16 — Admin Hinova sync.
    'policy',
    // Phase 11 docs-signature-payment Plan 10 — PreCompletionHub.
    'precompletion',
    // Phase 12 analista-queue-kpis-notif Plan 02.
    'analyst',
    'kpi',
    'notification',
    // Troca de titularidade (WAVE 2).
    'ownership_transfer',
    'war_room',
    // Phase 13 (ESCR-172.5) — Alamo Cobre.
    'competitor_offer',
    // Comissão MLM Genial.
    'commissions',
    // SGA/Hinova — consulta de carteira (tela /portfolio do consultor).
    'portfolio',
    'portfolio_transfer',
    // Endosso — tela /endossos.
    'endossos',
    // Lembretes do consultor (tela /agenda — ESCR-246).
    'reminders',
    // Central de Suporte / FAQ — vitrine do consultor.
    'support',
    // Relatórios gerenciais (menu Relatórios — admin/gerente).
    'reports',
  ],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export { i18n };
